import MealOrderList from "./MealOrderList.jsx";
export default MealOrderList;